import React from 'react';
import { Text } from '@chakra-ui/react';

const NewKBRecordCallModalHeaderContent = ({ lead }) => {
  return (
    <>
      Record Call
      {lead?.brideAndGroomName ? ` - ${lead.brideAndGroomName}` :
       lead?.name ? ` - ${typeof lead.name === 'string' ? lead.name : JSON.stringify(lead.name)}` : ''}
      {lead?.phone ? (
        <>
          {' • '}
          <Text
            as="a"
            href={`tel:${lead.phone.replace(/[^0-9+]/g, '')}`}
            color="blue.500"
            fontWeight="bold"
            _hover={{ textDecoration: 'underline' }}
            display="inline-flex"
            alignItems="center"
          >
            📞 {lead.phone.startsWith('+91') ? lead.phone.substring(3) : lead.phone}
          </Text>
        </>
      ) : ''}
    </>
  );
};

export default NewKBRecordCallModalHeaderContent;